export enum SlideDirection {
  Previous = 'previous',
  Next = 'next',
}
